export enum Roles {
    Admin = 'admin',
    Agent = 'Agent',
    Agency = 'Agency',
    InvitedAgency = 'InvitedAgency',
    InvitedAgent = 'InvitedAgent',
    Fmo = 'FMO',
    AgencyStaff = 'AgencyStaff'
  }